var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Add new User'}}),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_vm._v("Side Menu")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-6 col-sm-12"},[_vm._v("Panel")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/users/UserAdd.vue